import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Toaster } from 'sonner'
import { AuthProvider } from './contexts/AuthContext'
import { WalletProvider } from './contexts/WalletContext'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <AuthProvider>
                <WalletProvider>
                    <App />
                    <Toaster
                        position="top-center"
                        richColors
                        closeButton
                        toastOptions={{
                            style: {
                                background: 'rgba(26, 31, 58, 0.95)',
                                border: '1px solid rgba(6, 182, 212, 0.3)',
                                color: '#fff',
                                backdropFilter: 'blur(20px)',
                            },
                        }}
                    />
                </WalletProvider>
            </AuthProvider>
        </BrowserRouter>
    </React.StrictMode>,
)
